// Little Ounce: появление блоков при прокрутке. Без библиотек.
(function () {
  if (window.__loReveal) return;
  window.__loReveal = true;
  document.documentElement.classList.add('lo-js');
  var io = null;
  function run(root) {
    var els = (root || document).querySelectorAll('.lo-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); }); else run();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
